import Amplify, { Storage } from "aws-amplify";
import AWS from "aws-sdk";
import http from "../../utils/http_client";
import awsconfig from "../../config";

async function uploadPolicy(bucket: string, file: any) {
  try {
    const fileName = file.name;
    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        region: awsconfig.cognito.REGION,
        userPoolId: awsconfig.cognito.USER_POOL_ID,
        identityPoolId: awsconfig.cognito.IDENTITY_POOL_ID,
        userPoolWebClientId: awsconfig.cognito.APP_CLIENT_ID
      },
      Storage: {
        AWSS3: {
          bucket: bucket,
          region: awsconfig.cognito.REGION
        }
      }
    });
    Storage.put(fileName, file, {
      customPrefix: {
        public: ""
      },
      ACL: "public-read",
      visibility: "public",
      level: "public"
    })
      .then(result => result)
    return await http.postJson(
      "https://hup7d519i8.execute-api.us-east-1.amazonaws.com/dev/invalidate",
      { bucket, fileName }
    );
  } catch (e) {
      e
  }
}

export default {
  uploadPolicy
};
